import { Injectable, OnInit, Injector, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pais } from './lib/model/pais';
import { Localitat } from './lib/model/localitat';
import { Trasllat } from './lib/model/trasllat';
import { IName } from './lib/model/iname';
import { Estudi } from './lib/model/estudi';
import { Universitat } from './lib/model/universitat';
import { TipusDocument } from './lib/model/tipusDocument';
import { BLPais } from './lib/bl/blpais';
import { BLLocalitat } from './lib/bl/bllocalitat';
import { BLUniversitat } from './lib/bl/bluniversitat';
import { Oferta } from './lib/model/oferta';
import { BLOferta } from './lib/bl/bloferta';
import { Alumne } from './lib/model/alumne';
import { Utilitats } from './lib/utilitats';
import { environment } from '../environments/environment';

@Injectable()
export class DataService {

    trasllat: Trasllat = new Trasllat();

    paisosInitialized = false;
    localitatsInitialized = false;
    universitatsInitialized = false;
    current_language = 'ca';

    languages_app = [
        {value: 1, name: 'ca'},
        {value: 2, name: 'es'},
        {value: 4, name: 'en'}
      ];

    paisos: Pais[];
    poblacions: Localitat[];
    universitats: Universitat[];
    maxStep = 1;

    constructor(
        private http: HttpClient,
        public utilitats: Utilitats) {
    }

    public init(language: string) {
        this.current_language = language;
        this.trasllat.idioma = this.current_language;
        this.loadLocalitats();
        this.loadUniversitats();
        this.loadPaisos();
    }

    public stepPerformed(step: number): boolean {
        try {
            if (!this.trasllat.isnew) {
                return true;
            }
            return step <= this.maxStep;
        } catch (ex) {
            console.log(ex.Message);
        }
    }

    getApiEndpoint(controller: String) {
        const apiUrl = environment.apiUrl;
        return apiUrl + controller;
    }

    async loadPaisos() {
        const bl = new BLPais(this, this.http);
        this.paisos = await bl.list(this.current_language);
    }

    async loadLocalitats() {
        const bl = new BLLocalitat(this, this.http);
        this.poblacions = await bl.list();
    }

    async loadUniversitats() {
        const bl = new BLUniversitat(this, this.http);
        this.universitats = await bl.list(new Pais('Espanya', 72));
    }

    filtraPaisos(x: string): Pais[] {
        const z = this;
        return this.paisos.filter(function(y) {
            const x1 = z.normalize(z.utilitats.getString(x).toLowerCase());
            const y1 = z.normalize(y.name.toLowerCase());
            return y1.includes(x1);
        });
        // y.name.toLowerCase().indexOf(this.getString(x).toLowerCase()) === 0);
    }

    filtraPoblacions(x: string): Localitat[] {
        const z = this;
        return this.poblacions.filter(function(y) {
                const y1 = z.normalize(y.name.toLowerCase());
                const x1 = z.normalize(z.utilitats.getString(x).toLowerCase());
                return y1.includes(x1);
            }).sort( (a, b) => {
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            });
    }

    filtraUniversitats(x): Universitat[] {
        const z = this;
        return this.universitats.filter(function(y) {
            const x1 = z.normalize(z.utilitats.getString(x).toLowerCase());
            const y1 = z.normalize(y.name.toLowerCase());
            return y1.includes(x1);
        });
    }

    public normalize(x: string): string {
        return x.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/data.service.ts